<template>
  <h1 :style="style"><slot/></h1>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'TitleSection',
  props: {
    color: {
      type: String,
      default: colors.blue
    },
    marginOff: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      return {
        marginTop: this.marginOff ? 0 : '120px',
        marginBottom: this.marginOff ? 0 : '62px',
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 40px;
  font-weight: 600;
}
</style>
